export default "__VITE_ASSET__97b28938__"